import React, { useState, useEffect, useCallback } from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';
import { get } from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';

import Loading from '../../components/Loading';
import axios from '../../services/axios';
import Breadcrumbs from '../../components/Breadcrumbs';
import { useNotification } from '../../components/Notification/NotificationContext';
import Forms from '../../components/Forms';
import ErrorProcessor from '../../components/ErrorProcessor';
import PageHeader from '../../components/PageHeader';

export default function Channel() {
  const routeName = '/channels';
  const titleName = 'Fonte de lead';
  const [dataLoaded, setDataLoaded] = useState(false);
  const [apiErrors, setApiErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const notification = useNotification();
  const navigate = useNavigate();
  const params = useParams();
  const id = get(params, 'id', '');
  const [companies, setCompanies] = useState([]);
  const [channelsTypes, setChannelsTypes] = useState([]);
  const [formValues, setFormValues] = useState({
    name: '',
    auth: '',
    check_frequency: 520,
  });

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .min(3, 'Nome deve conter no mínimo 3 caracteres.')
      .required('Nome obrigatório.'),
    company_id: Yup.number().required('Empresa obrigatória.'),
    channel_type_id: Yup.number().required('Tipo e fonte obrigatória.'),
    check_frequency: Yup.number().required(
      'Frequência de sincronismo obrigatório.'
    ),
  });

  const handleFieldChange = useCallback((fieldName, value) => {
    setFormValues((prevValues) => ({ ...prevValues, [fieldName]: value }));
  }, []);

  const fields = [
    {
      name: 'name',
      id: 'name',
      label: 'Nome',
      type: 'text',
      onChange: (e) => handleFieldChange('name', e.target.value),
      colSize: 4,
      additionalProps: {},
    },
    {
      name: 'company_id',
      id: 'company_id',
      label: 'Empresa',
      type: 'select',
      options: companies,
      onChange: (e) => handleFieldChange('company_id', e.target.value),
      colSize: 4,
      additionalProps: {},
    },
    {
      name: 'channel_type_id',
      id: 'channel_type_id',
      label: 'Tipo de fonte',
      type: 'select',
      options: channelsTypes,
      onChange: (e) => handleFieldChange('channel_type_id', e.target.value),
      colSize: 4,
      additionalProps: {},
    },
    {
      name: 'check_frequency',
      id: 'check_frequency',
      label: 'Frequência de sincronismo (segundos)',
      type: 'number',
      onChange: (e) => handleFieldChange('check_frequency', e.target.value),
      colSize: 4,
      additionalProps: {},
    },
    {
      name: 'auth',
      id: 'auth',
      label: 'Autenticação',
      type: 'textarea',
      onChange: (e) => handleFieldChange('auth', e.target.value),
      colSize: 8,
      additionalProps: {},
    },
  ];

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      let action = 'cadastrado';

      if (id) {
        await axios.put(`${routeName}/${id}`, formValues);
        action = 'atualizado';
      } else {
        await axios.post(routeName, formValues);
      }
      axios.put('/reloadschedule');
      navigate('/channels');
      notification(`${titleName} ${action} com sucesso`, 'success');
    } catch (err) {
      setApiErrors(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    async function getData() {
      try {
        setIsLoading(true);

        const optionsCompanies = [{ value: '', label: '-- Selecione --' }];
        const optionsChannelsTypes = [{ value: '', label: '-- Selecione --' }];
        const getCompanies = await axios.get(`/companies`);
        const getChannelsType = await axios.get(`/channelstypes`);

        if (getCompanies) {
          getCompanies.data.forEach((data) => {
            optionsCompanies.push({
              value: data.id,
              label: data.name,
            });
          });
        }

        if (getChannelsType) {
          getChannelsType.data.forEach((data) => {
            optionsChannelsTypes.push({
              value: data.id,
              label: data.name,
            });
          });
        }

        setCompanies(optionsCompanies);
        setChannelsTypes(optionsChannelsTypes);
        if (id) {
          const getChannel = await axios.get(`${routeName}/${id}`);
          console.log(getChannel.data);
          setFormValues({
            ...getChannel.data,
          });
        }
      } catch (err) {
        setApiErrors(err);
      } finally {
        setIsLoading(false);
        setDataLoaded(true);
      }
    }

    getData();
  }, [id, notification, navigate]);

  return (
    <Container fluid className="px-lg-4 px-xl-5">
      <Loading isLoading={isLoading} />
      <Breadcrumbs
        title={id ? 'Atualizar' : 'Cadastrar'}
        pages={[{ link: '/channels', name: 'Fontes de leads' }]}
      />
      <PageHeader title={titleName} />
      <section>
        <Row>
          <Col lg={12}>
            <Card className="mb-5">
              <Card.Header>
                <h4 className="card-heading">
                  {id ? `Atualizar ${titleName}` : `Cadastrar ${titleName}`}
                </h4>
              </Card.Header>
              <Card.Body>
                <ErrorProcessor error={apiErrors} />
                {!id || dataLoaded ? (
                  <Forms
                    // key={JSON.stringify(initialValues)}
                    initialValues={formValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    fields={fields}
                    btnSubmit={{
                      variant: 'primary',
                      type: 'submit',
                      text: id ? 'Atualizar' : 'Cadastrar',
                    }}
                  />
                ) : null}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </section>
    </Container>
  );
}
